'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
interface ReactNativeWebView {
  postMessage: (message: string) => void;
}
declare global {
  interface Window {
    ReactNativeWebView?: ReactNativeWebView;
  }
}
export const useTossWebView = () => {
  const $ = _c(5);
  const [isModalOpened, setIsModalOpened] = useState(false);
  const closeWebView = _temp;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsModalOpened(true);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const openConfirmModal = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsModalOpened(false);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const closeConfirmModal = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsModalOpened(false);
      closeWebView();
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const confirmAndClose = t2;
  let t3;
  if ($[3] !== isModalOpened) {
    t3 = {
      closeWebView,
      openConfirmModal,
      closeConfirmModal,
      confirmAndClose,
      isModalOpened
    };
    $[3] = isModalOpened;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
function _temp() {
  window.ReactNativeWebView?.postMessage(JSON.stringify({
    name: "windowClose"
  }));
}